/* eslint-disable import/prefer-default-export */
import * as scheduleActions from './actions';

/**
 * @param {Moment} activeDate
 * @param {String} mode
 * @param {String} subject
 */
export const updateScheduleConfig = (activeDate, mode, subject) => dispatch => {
  dispatch(scheduleActions.setActiveDate(activeDate));
  dispatch(scheduleActions.setScheduleMode(mode));
  dispatch(scheduleActions.setScheduleSubject(subject));
};
